import React from 'react';
import { SidebarProvider, useSidebar } from '@/components/ui/sidebar';
import { AppSidebar } from './AppSidebar';
import { AppNavbar } from './AppNavbar';
import { cn } from '@/lib/utils';

// Inner component that can use useSidebar hook
function MainContent({ children, className }) {
    const { state } = useSidebar();
    const isCollapsed = state === 'collapsed';
    
    return (
        <main 
            className={cn(
                "main-content bg-background pb-8",
                isCollapsed && "sidebar-collapsed",
                className
            )}
        >
            <div className="p-2 sm:p-4 md:p-6">
                {children}
            </div>
        </main>
    );
}

export function PagesWrapper({ children, className }) {
    return (
        <SidebarProvider>
            <div className="relative min-h-screen w-full">
                {/* Fixed navbar at top */}
                <AppNavbar />
                
                {/* Sidebar (fixed position) */}
                <AppSidebar />
                
                {/* Main content with padding for sidebar */}
                <MainContent className={className}>
                    {children}
                </MainContent>
            </div>
        </SidebarProvider>
    );
}

export default PagesWrapper;
